import { BaseService } from '@myhealth-raccoon/services';

import { TokenResponse } from '../auth';

class UmbracoService extends BaseService {
    constructor() {
        super('api/booking', import.meta.env.VITE_MYHEALTH_WEBSITE);
    }

    public async GetBookingToken() {
        return await this.get<TokenResponse>('Token');
    }
}

export const umbracoService = new UmbracoService();
